const clean = (value) => {
  const normalized = String(value || "").trim();
  return normalized || null;
};

export const LEGAL_ENTITY_TYPES = Object.freeze({
  INDIVIDUAL: "INDIVIDUAL",
  ORGANIZATION: "ORGANIZATION",
});

// Identidade pública da fase inicial. CPF e endereço residencial nunca devem ser
// adicionados a variáveis REACT_APP_* porque elas são incorporadas ao bundle web.
export const LEGAL_IDENTITY = Object.freeze({
  legalEntityType: LEGAL_ENTITY_TYPES.INDIVIDUAL,
  legalName: clean(process.env.REACT_APP_LEGAL_NAME),
  tradeName: "Zuno",
  taxId: null,
  address: null,
  privacyController: clean(process.env.REACT_APP_PRIVACY_CONTROLLER) || clean(process.env.REACT_APP_LEGAL_NAME),
  privacyContact: "privacidade@zunomovel.com.br",
  supportEmail: "contato@zunomovel.com.br",
  site: "https://www.zunomovel.com.br",
  country: "Brasil",
  organizationConstituted: false,
  dpoStatus: "LEGAL_REVIEW_REQUIRED",
});

// Estado administrativo: pode aparecer no painel e em auditorias, nunca na UI pública.
export const LEGAL_IDENTITY_ADMIN_STATUS = Object.freeze({
  missingFields: Object.freeze([
    ...(LEGAL_IDENTITY.legalName ? [] : ["LEGAL_NAME"]),
    ...(LEGAL_IDENTITY.privacyController ? [] : ["PRIVACY_CONTROLLER"]),
  ]),
  taxIdVisibility: "PRIVATE_ADMIN_ONLY",
  addressVisibility: "PRIVATE_ADMIN_ONLY",
});

export const publicOperatorDescription = () => LEGAL_IDENTITY.legalName
  ? `${LEGAL_IDENTITY.legalName}, pessoa natural responsável pela plataforma Zuno, nesta fase inicial do projeto.`
  : "A Zuno é operada, nesta fase inicial do projeto, por pessoa natural. A denominação Zuno identifica a plataforma e não representa, por si só, uma pessoa jurídica constituída.";

export const publicPrivacyControllerDescription = () => LEGAL_IDENTITY.privacyController
  ? `${LEGAL_IDENTITY.privacyController}, pessoa natural responsável pela plataforma Zuno.`
  : "A pessoa natural responsável pela plataforma Zuno atua como controladora dos dados pessoais nesta fase inicial do projeto.";
